export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
export const PLATFORM_NAMES: Record<string, string> = { n64: 'Nintendo 64', gba: 'Game Boy Advance' };
